export default __webpack_public_path__ + "static/media/MM-Seas-Logo-transparent.e8bd4599.png";